// extracted by mini-css-extract-plugin
module.exports = {"container":"Document_container__2ZHB-","canvas":"Document_canvas__3i-PM"};